import {memo} from 'react';

import {useSelector} from 'react-redux';
import {findIndex} from 'lodash';

import {SkeletonLoader} from '~/shared/components/Loaders';
import {
  selectCurrentAddress,
  selectOrdersHistory,
  selectOrdersHistoryLoaded,
  selectOrdersHistoryLoading,
} from '~/shared/store/selectors';
import {handleOnReorderClick, handleOnPreviewClick} from '~/shared/utils/reorder/utils';

import ReorderLoaderComponent from '../Dropdown/components/ReorderLoaderComponent';
import {ReorderItemsContainer} from '../dropdown.styled';
import NoReorders from '../NoReorders';
import ReorderList from '../ReorderList';

export const ReorderPageComponent = memo(() => {
  const currentAddress = useSelector(selectCurrentAddress);
  const reorderItems = useSelector(selectOrdersHistory);
  const isReorderListLoaded = useSelector(selectOrdersHistoryLoaded);
  const isReorderListLoading = useSelector(selectOrdersHistoryLoading);
  const showNoReorders = (isReorderListLoaded && reorderItems.length <= 0) || !currentAddress?.addressId;

  return (
    <SkeletonLoader
      isPage
      shouldShowLoader={!!currentAddress?.addressId && (!isReorderListLoaded || isReorderListLoading)}
      LoaderComponent={ReorderLoaderComponent}
    >
      <ReorderItemsContainer isPage showNoReorders={showNoReorders}>
        {showNoReorders ? (
          <NoReorders isPage />
        ) : (
          <ReorderList
            items={reorderItems}
            isPage
            handleOnPreviewClick={({orderId, restaurantId}) => {
              const orderPositionInList = findIndex(reorderItems, {orderId}) + 1;
              handleOnPreviewClick({orderId, restaurantId, orderPositionInList});
            }}
            handleOnReorderClick={({orderId, restaurantId}) =>
              handleOnReorderClick({orderId, restaurantId, reorderItems})}
          />
        )}
      </ReorderItemsContainer>
    </SkeletonLoader>
  );
});
